export enum SalesforceEvents {
  ConditionReport = 'Condition Report',
  InitialReport = 'Initial Report',
  ReleaseReport = 'Release Report',
  ConditionReportDelete = 'Condition Report - Delete',
  DailyChiroUpUsage = 'Daily ChiroUp Usage',
  ChiefComplaintSurvey = 'Chief Complaint Survey',
  Survey = 'Survey',
  Microsurvey = 'Microsurvey',
  ChurnKeyFlow = 'ChurnKey Flow',
  VoiceToChartUpgrade = 'Voice to Chart Upgrade',
  VoiceToChartCancel = 'Voice to Chart Cancel',
  AdvancedMessagingUpgrade = 'Advanced Messaging Upgrade',
  AdvancedMessagingCancellation = 'Advanced Messaging Cancellation',
  EhrInterest = 'EHR Interest',
  SaopWizardStarted = 'SAOP Wizard Started',
  SaopWizardSignNoteClicked = 'SAOP Wizard Sign Note Clicked',
  // One-time TTFV intent-modal answer; Additional_Information__c carries the
  // display value (TRIAL_INTENT_LABELS). SF-side Flows own all Opportunity
  // stamping/backfill — the app only publishes the Platform_Event__c.
  TrialIntent = 'Trial Intent',
  AiReceptionistUpgrade = 'AI Receptionist Upgrade',
  AiReceptionistCancellation = 'AI Receptionist Cancellation',
}

export enum SalesforceActions {
  createLead = 'createLead',
  updateClinic = 'updateClinic',
  updateUser = 'updateUser',
  addToClinic = 'addToClinic',
  removeFromClinic = 'removeFromClinic',
  event = 'event',
}
